import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { searchAssets } from '../services/svp/assets';

import type { SvpFetchParams } from '../services/svp/shared/requestSVP';

export const useSearchAssets = (
  params: SvpFetchParams | undefined,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: ['svp-search-assets', params],
    queryFn: ({ signal }) => searchAssets(params!, signal),
    enabled: options?.enabled ?? Boolean(params),
    placeholderData: keepPreviousData,
  });
};
